/**
 * Created by nir on 20/07/2016.
 */

if (window.jQuery) {
    window.jQuery(function ($) {

        var mobileGenres = $('#mobile-genres'),
            nav = $('nav#top-nav');

        // genre click tracking
        nav.on('click', '.genre-icons li a[href]', function () {
            var genre = $(this).find('.genre-name').text().trim();
            TCT.debug('Nav button clicked', genre, this);
            if (genre) trackCTA('TopNav_GenreButton', genre);
            return true;
        });

        mobileGenres.on('scroll', function () {
            var atStart = mobileGenres[0].scrollLeft == 0,
                atEnd = mobileGenres[0].scrollLeft == (mobileGenres[0].scrollWidth - mobileGenres[0].clientWidth);

            nav.toggleClass('at-start', atStart).toggleClass('at-end', atEnd);
        });


    });


}

/**
 * Created By Raz On 13/12/2016
 */
if (window.jQuery) {
    window.jQuery(function ($) {

        $('.no-touchevents #nav-genres ul li.maing a, .no-touchevents #sticky-genre ul li.maing a').hover(function () {
            $('#nav-genres ul li.maing, #sticky-genre ul li.maing').removeClass('active');
            $(this).parent().addClass('active');

            target = $(this).attr('thetarget');
            $('#subnav .content').not('#' + target).hide();
            $('#subnav .content#' + target).show();
            $('.verticalarticles').show();
            $('.genrearticles').hide();
            if ($('#subnav').not(':visible')) {
                $('#subnav').show();
            }
        });


        $('.touchevents #nav-genres ul li.maing a, .touchevents #sticky-genre ul li.maing a').on('touchstart', function() {
            $('#nav-genres ul li.maing, #sticky-genre ul li.maing').removeClass('active');
            $(this).parent().addClass('active');

            target = $(this).attr('thetarget');
            $('#subnav .content').not('#' + target).hide();
            $('#subnav .content#' + target).show();
            $('.verticalarticles').show();
            $('.genrearticles').hide();
            if ($('#subnav').not(':visible')) {
                $('#subnav').show();
            }
        });


        //make sure links won't work on click when on touch

        $('#nav-genres ul li.maing a, #sticky-genre ul li.maing a, .genres ul li.vertical-genre').click(function (e) {
            if ($('html').hasClass('touchevents')) {
                e.preventDefault();
            }
        });

        $('.no-touchevents #subnav').mouseleave(function () {
            $('#nav-genres ul li.maing, #sticky-genre ul li.maing').removeClass('active');
            $('#nav-genres ul li.maing[tag="selected"], #sticky-genre ul li.maing[tag="selected"]').addClass('active');
            if ($('#subnav').is(':visible')) {
                $('#subnav').hide();
            }
        });

        $('.genres ul li.vertical-genre a').hover(function () {
            vertical = $(this).parent().attr('vertical');
            target = $(this).parent().attr('thetarget');
            $('#subnav .content#' + vertical + ' .genres ul li.vertical-genre a').removeClass('selected');
            $(this).addClass('selected');
            $('#' + vertical + '_articles .verticalarticles').hide();
            $('#' + vertical + '_articles .genrearticles').show();
            $('#' + vertical + '_articles .genrearticles .genrearticle').hide();
            $('#' + vertical + '_articles .genrearticles .genrearticle#' + target).css('display', 'flex');
        });

        $('.genres ul li.vertical-title').hover(function () {
            vertical = $(this).attr('vertical');
            $('#subnav .content#' + vertical + ' .genres ul li.vertical-genre a').removeClass('selected');
            $('#' + vertical + '_articles .genrearticles').hide();
            $('#' + vertical + '_articles .verticalarticles').show();
        });

        // for touch devices. One touch opens menu, second touch goes to link.
        $('.touchevents .maing, .touchevents .vertical-genre').on("touchstart", function(e){
            if ($('.touchevents .maing').is(e.target)){
                 $('.touchevents .maing').not(this).removeClass('clicked_once');
            }
            $('.touchevents .vertical-genre').not(this).removeClass('clicked_once');
            if ($(this).hasClass('clicked_once')){
                Thelink = $(this).find('a').attr('href');
                window.location = Thelink;
            }
            $(this).addClass('clicked_once');


        });
        //one touch outside the nav bar, closes it.
        $('html.touchevents').on("touchstart", function(e){
            var container = $(".touchevents .maing, .touchevents .vertical-genre");
            if (!container.is(e.target) && container.has(e.target).length === 0){
                if ($('#subnav').is(':visible')) {
                    $('#nav-genres ul li.maing, #sticky-genre ul li.maing').removeClass('active');
                    $('#subnav .content .genres ul li.vertical-genre a').removeClass('selected');
                    $('.maing').removeClass('clicked_once');
                    $('#nav-genres ul li.maing, #sticky-genre ul li.maing').removeClass('active');
                    $('.vertical-genre').removeClass('clicked_once');
                    $('#subnav').hide();
                }
            }

        });

    });
}
//// ANGULAR

var subNavApp = angular.module('subNavApp', []);

subNavApp.controller('subNavControll', ['$scope', '$log', '$http', '$window', function($scope, $log, $http, $window) {

    //create vertical articles and genre articles objects
    $scope.verticalarticles = {};
    $scope.genresarticles = {};

    // number of characters limitation for the articles' titles in the subnav
    $scope.limitnum = 45;
    $scope.trackCTA = $window.trackCTA;
    $scope.showprogress = true;
    $scope.showloadingbtn = true;

    $scope.init = function (locationID, articlesPerGenre, verticals, sponsoredLabel, vertical, type, hp) {
        $scope.locationID = locationID;
        $scope.articlesPerGenre = articlesPerGenre;

        if(parseInt(hp)){
            $scope.hp = "&hp=1";
        }else{
            $scope.hp = "&hp=0";
        }
        $scope.verticals = verticals.split(",").map(function (item) {
            return parseInt(item);
        });
        $scope.sponsoredLabel = sponsoredLabel;

        $scope.vertical = vertical;

        $scope.pageType = type;

        $http.get(TCTServer.api + 'v1/articles/locations/' + $scope.locationID + '?data=true&postPerCategory=' + $scope.articlesPerGenre + '&queryType=topNav&category='+$scope.vertical+$scope.hp).then(function (response) {
            var data = response.data;
            //create verticals articles
            angular.forEach(data['articleResources'], function ($value) {

                if ($scope.verticals.indexOf($value.groupID) > -1) {
                    if (!$scope.verticalarticles.hasOwnProperty($value.groupID)) {
                        $scope.verticalarticles[$value.groupID] = [];
                    }
                    if ($scope.verticalarticles[$value.groupID].length < $scope.articlesPerGenre) {

                        if ($value.isSponsored == true) {
                            $value.articleCategory = $scope.sponsoredLabel;
                        }
                        $scope.verticalarticles[$value.groupID].push($value);
                    }
                }
            });

            //create genres articles
            angular.forEach(data['articleResources'], function ($value) {
                if (!$scope.genresarticles.hasOwnProperty('genre_' + $value.categoryID)) {
                    $scope.genresarticles['genre_' + $value.categoryID] = [];
                }
                if ($scope.genresarticles['genre_' + $value.categoryID].length < $scope.articlesPerGenre)
                    $scope.genresarticles['genre_' + $value.categoryID].push($value);
            });

            $scope.showprogress = false;
            $scope.showloadingbtn = false;

        }, function (errors) {
            TCT.warn('API call error', errors);
            $scope.showprogress = false;
        });
    }
}]);

// a limit filter for angular. recieves the VALUE you want to limit
//WORDWISE - true or false, determines if the text will be cut mid-word of after a word
// MAX - number of maximum characters for your value. 
// TAIL - an addition you may want to add to the cut value (could be "read more" or something similar, default is ...)
angular.module('subNavApp').filter('cut', function () {
    return function (value, wordWise, max, tail) {
        if (!value) return '';

        max = parseInt(max, 10);
        if (!max) return value;
        if (value.length <= max) return value;

        value = value.substr(0, max);

        if (wordWise) {
            var lastSpace = value.lastIndexOf(' ');

            if (lastSpace != -1) {
                //Also remove . and , so its gives a cleaner result.
                if (value.charAt(lastSpace - 1) == '.' || value.charAt(lastSpace - 1) == ',') {
                    lastSpace = lastSpace - 1;
                }
                value = value.substr(0, lastSpace);
            }
        }

        return value + (tail || ' …');
    };
});

angular.bootstrap(document.getElementById('locationVertical'), ['subNavApp']);
angular.bootstrap(document.getElementById('genre-sections'), ['subNavApp']);